import { render, staticRenderFns } from "./notificationSetting.vue?vue&type=template&id=ad32fb12&lang=pug"
import script from "./notificationSetting.vue?vue&type=script&lang=js"
export * from "./notificationSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports